import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67e2ab29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title-2 mb_20" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-divide" }, null, -1))
const _hoisted_4 = { class: "text-lf" }
const _hoisted_5 = { class: "text-rt" }

import TableLike from '@/components/common/TableLike.vue'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import {
  brandAuthAuditList
} from '@/apis/brand'


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: true },
    close: { type: Function, required: true }
  },
  setup(__props: any) {

const props = __props as {id:string, close:()=>void}
const columns = [
  { label: '时间1', prop: 'auditTime', width: 120 },
  { label: '内容', prop: 'content', slotName: 'content' },
  { label: '操作后状态', prop: 'afterStatus', width: 120 }
].fort()



brandAuthAuditList({
  applyId: props.id
}).setSite(res => {
  console.log(res.data)
  if (res.success) {
    data.value = res.data
  }
})

const data = ref([])

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('审核详情')), 1),
    _hoisted_3,
    _createVNode(TableLike, {
      class: "table",
      columns: _unref(columns),
      data: data.value,
      divide: true
    }, {
      content: _withCtx(({ item }) => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.content.split('\n'), (v) => {
            return (_openBlock(), _createElementBlock("div", {
              key: v,
              style: {"line-height":"22px"}
            }, _toDisplayString(v), 1))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["columns", "data"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        type: "primary",
        size: "large",
        onClick: __props.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}
}

})